<template>
  <div class="gz-swiper" >
    <div class="swiper-button-prev" slot="button-prev" v-show="CabinetList.length !=0"></div>
    <div  v-if="CabinetList.length>0" class="swiper-no-swiping">
      <swiper class="swiper" :options="swiperOption" v-if="showSwiper">
        <template   v-for="(item, gzindex) in CabinetList" >
          <swiper-slide :key="gzindex">
              <div class='gz-info'>
                <div class='gzNumber'>
                  <div class="icon-bg"><i class="iconfont icon-iconset0499"></i></div>
                  <span class="gz-title"> {{item.name}}</span>
                </div>
                <div class='gzNumber'>
                  <div class="icon-bg"><i class="iconfont icon-guizi"></i></div>
                  <span class="gz-title">{{item | Hasused}}</span>
                </div>
              
                <el-checkbox-group v-model="checkList" @change="bindCheckBox">
                <el-checkbox :label="item.id" :key="item.id"><br></el-checkbox>
              </el-checkbox-group>
              </div>
            <div class="gz" >
              <div :class="['gz_content',item.boxes.length >10 ? 'bar' : '']" @mousemove="setScroolFun">
                <div :class="['gzall', 'grid_'+Math.ceil(item.boxes.length/2)]" >
                  <template  v-for="(box, boxIndex) in item.boxes" >
                    <div :class="['gzali-item', show == box.id ? 'gz_select' : '']"  :key="boxIndex" @click="binding(item,box)">
                      <ul>
                        <li>
                          <p class="boxIndex">{{ box.boxIndex }}</p>
                          <template v-if="box.states == 1">
                            <p><i class="el-icon-success"></i>在库</p>
                          </template>
                          <template v-if="box.states == 2">
                            <p style="color: #ff144e">
                              <i class="el-icon-warning"></i>取出
                            </p>
                          </template>
                          <template v-if="box.states == 0">
                            <p style="color: #999">
                              <i class="el-icon-remove"></i>未绑定仪器
                            </p>
                          </template>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </swiper-slide>
        </template>
      </swiper>
    </div>

    <div v-else class="not_info">
      <div class="info_text">{{gzInfoNone}}</div>
    </div>
    <div class="swiper-button-next" slot="button-next" v-show="CabinetList.length!=0"></div>
    <div></div>
    <div class="swiper-scrollbar" v-show="CabinetList.length!=0"></div>
    <div></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import addTemperature  from "./addTemperature";
import editPower from "./editPower";
import instrumentList from "./instrumentList";
import { PowerOn,createTherm,deletePower,powerBind,powerUnbind,powerUpdate,updateTherm } from "@/api/warehouse";
export default {
  name: "swiper-example-multiple-slides-per-biew",
  title: "Multiple slides per view",
  // props: ["DepotInfo",'CabinetList'],
  props:{
    DepotInfo:{
      type: Object,
      required: true
    },
    CabinetList:{
      type: Array,
      required: true,
      default:[]
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    addTemperature ,
    editPower,
    instrumentList
  },
  inject:['reload'],
  data() {
    return {
      checkList: [],
      cabinetParams:{},//仪器柜子需要数据
      editVisible: false,//电源控制器修改弹窗
      pbindVisible:false,//电源控制器绑定仪器弹窗
      show:'',//是否显示选中效果
      pInfo:'',//选中电源控制器信息
      Class: true,//切换显示样式(1个柜子还是多个柜子)
      gzInfoNone:'',
      dialogFormVisible: false,
      documentObj : null,//滚动事件
      documentObjX : null,//滚动事件
      InstrumentId:'',//选中仪器的id
      boxId:'',//选中电源控制器的boxId
      depotId:'',//仓库id
      PowerInfo:[],//电源控制器列表
      // swiper配置
      swiperOption: {
        initialSlide: 0,
        slidesPerView:3,
        spaceBetween: 75,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
      },
    };
  },
  created() {
    this.depotId = sessionStorage.getItem('depotId')
    if(!this.CabinetList){
      this.gzInfoNone = '当前仓库为空！'
    }
  },

  methods: {

    bindCheckBox(value){
      if(this.checkList.length > 1){
        this.checkList.splice(0,1)
      }
      this.$emit("checkListChose",this.checkList[0])
    },

    //柜子格口绑定
    binding(items,boxs) {
      this.$router.push({ path: "/warehouse/equipmentbind" ,query:{id:items.id,name:items.name}});
      this.show = boxs.id
      sessionStorage.setItem('boxId',boxs.id)
    },

    cancel() {
      this.dialogFormVisible = false;
      this.editVisible = false;
      this.pbindVisible = false;
    },

    setScroolFun () {
      this.documentObj = null;
      this.documentObj = document.querySelector('.gzall')
      // 添加监听事件
      if(this.documentObj){
        this.documentObj.style = 'padding-left: 15px'
      }
    },

  },
  computed: {
    showSwiper() {
      return this.CabinetList.length
    },
  },
  filters:{
    Hasused:function(val){
      let sum = val.boxes.length
      let n = 0
      val.boxes.forEach(item=>{
        if(item.states == 1){
          n++
        }
      })
      return `${n}/${sum}`
    }
  }

};
</script>
<style lang="less" scoped>
.bar{
  cursor: pointer;
}
.bar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
.swiper {
  width: 100%;
  padding-bottom: 20px;
  /deep/.swiper-container {
    position: static;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    font-weight: bold;
  }
}

.gz-swiper {
  display: grid;
  grid-template-columns:4% 92% 4%;
  grid-template-rows:99% 1%;
  width: 100%;
  // width: calc(100% - 170px);
  /deep/ .swiper-button-prev:after{

    left: 172px !important;
    width: 44px !important;
    height: 11px !important;
    border: 2px solid;
    border-radius: 59%;
    padding: 13px 18px 20px 16px;
    outline: none;
    font-size: 20px!important;
  }
  .swiper-button-prev{
    margin: 297px auto;
    position: static !important;
    outline: none;
  }
  /deep/ .swiper-button-next:after
  {
    left: 172px !important;
    width: 44px !important;
    height: 11px !important;
    border: 2px solid;
    border-radius: 59%;
    padding: 13px 16px 20px 18px;
    outline: none;
    font-size: 20px!important;
  }
  .swiper-button-next{
    margin: 297px auto;
    position: static !important;
    outline: none;
  }

  .swiper-scrollbar{
    height: 8px;
    background: #1f94f1;
  }
  /deep/.swiper-scrollbar-drag{
    cursor: pointer;
    background: #86cbfd !important;
  }
  .gz-info{
    padding-left: 4px;
    position:absolute;
    top:8px;
    box-sizing: border-box;
    display: flex;
    grid-template-columns: repeat(2, 49%);
    width: 400px;
    .gzNumber{
      margin: 0 auto;
      height: 30px;
      line-height: 30px;
      font-size:18px;
      color: #0153e9;
      border-radius: 6px;
      display: flex;
      align-items: center;
      font-weight: normal;
      .icon-bg{
        width: 30px;
        text-align: center;
        position: relative;
        left: -2px;
        line-height:28px;
        i{
          font-size:20px
        }
      }
      .gz-title{
        margin: 0 auto;
        font-weight:500;
      }
    }
  }
  // 柜子样式
  .gz {
    width: 447px;
    height: 740px;
    background: url(~@/assets/images/gz.png);
    background-size: 100% 100%;
    .gz_content{
      margin-top: 50px;
      margin-right: 5px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  .grid_1{
     grid-template-rows: repeat(1, 20%);
   }
  .grid_2{
   grid-template-rows: repeat(2, 20%);
  }
  .grid_3{
    grid-template-rows: repeat(3, 20%);
  }
  .grid_4{
    grid-template-rows: repeat(4, 20%);
  }
  .grid_5{
    grid-template-rows: repeat(5, 20%);
  }
  .grid_6{
    grid-template-rows: repeat(6, 20%);
  }
  .grid_7{
    grid-template-rows: repeat(7, 20%);
  }
  .grid_8{
    grid-template-rows: repeat(8, 20%);
  }
  .grid_9{
    grid-template-rows: repeat(9, 20%);
  }
  .grid_10{
    grid-template-rows: repeat(10, 20%);
  }
  .gzall {
    padding-left: 15px;
    width: 428px;
    height: 687px;
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(2, 46%);
    grid-auto-flow: column ;
    grid-column-gap: 15px;
    .gz_select{
      box-shadow: 0 0 10px rgba(255,255,255,0.8);
      border-radius:20px;
    }
    .gzali-item {
      width: 194px;
      height: 125px;
      background: url(~@/assets/images/gm.png);
      background-size: 100% 100%;
      float: left;
      font-size: 12px;
      font-weight: normal;
      color: #00a9ff;
      display: grid;
      align-items: center;
      justify-content: center;
      text-align: center;
      cursor: pointer;
    }
      .boxIndex {
        font-size: 24px;
        margin-bottom: 5px;
        font-weight: 350;
      }
      .iconfont {
        font-size: 20px;
        margin-left: 70px;
      }
      /deep/ .el-badge__content {
        position: absolute;
        top: 0;
        right: 10px;
        -webkit-transform: translateY(-50%) translateX(100%);
        transform: translateY(-50%) translateX(100%);
      }
    }
  }
}

.block {
  width: 100px;
  position: relative;
  top: 358px;
  left: -300px;
  z-index: 1000;
}

.not_info{
  margin: 0 auto;
  margin-top: 20px;
  width: 1570px;
  color: #74c8fe;
  font-size: 24px;
  text-align: center;
  .info_text{
    margin-top:320px;
  }
}
ul,li {
  list-style: none;
  margin: 0;
  padding: 0;
  outline: none;
}

</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/gzSwiper.vue